export const HCFEE = 2;
export const LOCKOUT_THRESHOLD = 12;